export enum ProductNameEnum {
  QQpay = "QQpay",
  KaroPay = "KaroPay",
  TKPay = "TKPay",
  TGPay = "TGPay"
}
